import * as React from 'react'
import { t } from 'ttag'
import { tokens } from '../../styles/tokens'

interface SkipLinkProps {
  targetId?: string
}

export const SkipLink = ({ targetId = 'main' }: SkipLinkProps) => (
  <a
    href={`#${targetId}`}
    style={{
      position: 'absolute',
      left: '-9999px',
      top: 'auto',
      width: 1,
      height: 1,
      overflow: 'hidden',
      zIndex: 10000,
      background: tokens.surface.background,
      color: tokens.text.primary,
      padding: '8px 12px',
      borderRadius: 4,
      textDecoration: 'none',
      border: `2px solid ${tokens.border.focus}`,
    }}
    onFocus={(e) => {
      const el = e.currentTarget
      el.style.left = '16px'
      el.style.top = '16px'
      el.style.width = 'auto'
      el.style.height = 'auto'
    }}
    onBlur={(e) => {
      const el = e.currentTarget
      el.style.left = '-9999px'
      el.style.top = 'auto'
      el.style.width = '1px'
      el.style.height = '1px'
    }}
  >
    {t`Skip to main content`}
  </a>
)
